import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ByTypeChart: React.FC = () => {
  const [data, setData] = useState<any>({ labels: [], datasets: [] });
  const { data: dash } = useDashboardData();
  useEffect(() => {
    if (!dash) return;
    if (dash.queriesByType && dash.queriesByType.length > 0) {
      const labels = dash.queriesByType.map(x => x.type);
      const counts = dash.queriesByType.map(x => x.count);
      setData({ labels, datasets: [{ label: 'Queries', data: counts, backgroundColor: '#93c5fd' }] });
      return;
    }
    const map: Record<string, number> = {};
    (dash.queries||[]).forEach((q:any)=>{ const t=q.type||'Other'; map[t]=(map[t]||0)+1; });
    const labels = Object.keys(map);
    const counts = labels.map(l => map[l]);
    setData({ labels, datasets: [{ label: 'Queries', data: counts, backgroundColor: '#93c5fd' }] });
  }, [dash]);

  return (
    <div className="card">
      <h4 className="card-title">By Query Type</h4>
      <Bar data={data} />
    </div>
  );
};

export default ByTypeChart;
